import { Link } from 'react-router-dom';
import PhoneSupport from '../PhoneSupport/PhoneSupport';
import { openCookiePreferences } from '../../utils/analytics';

export default function Footer() {
	return (
		<footer className="footer">
			<div className="container footer__grid">
				<div className="footer__col">
					<h4>Akku 24+</h4>
					{/* The two bare tel: links were replaced by the header's reveal button so
					    footer clicks are tracked the same way (Analytics + visitor-session
					    phone_show). Both numbers stay machine-readable in the Organization
					    JSON-LD emitted from Layout. */}
					<PhoneSupport className="phonebtn--footer" />
					<nav>
						<a href="mailto:rendeles@akku-24.hu">rendeles@akku-24.hu</a>
						<span>1132 Budapest, Váci út 8.</span>
					</nav>
				</div>
				<div className="footer__col">
					<h4>Oldalak</h4>
					<nav>
						<Link to="/arlista">Árlista</Link>
						<Link to="/akkuvalaszto">Akkuválasztó</Link>
						<Link to="/blog">Blog</Link>
					</nav>
				</div>
				<div className="footer__col">
					<h4>Információ</h4>
					<nav>
						<Link to="/vasarlasi-feltetelek">Vásárlási feltételek</Link>
						<Link to="/adatvedelem">Adatvédelmi tájékoztató</Link>
						{/* Reopens TermsFeed's preferences centre so tracking consent can be
						    withdrawn any time — required once the GA4 consent banner exists. */}
						<a
							href="#cookie-beallitasok"
							onClick={(e) => {
								e.preventDefault();
								openCookiePreferences();
							}}
						>
							Cookie beállítások
						</a>
						<a href="https://www.facebook.com/akku24" target="_blank" rel="noopener noreferrer">Facebook</a>
					</nav>
				</div>
			</div>
			<div className="container">
				<p className="footer__copyright">© {new Date().getFullYear()} Akku 24+ — akku-24.hu · Minden jog fenntartva.</p>
			</div>
		</footer>
	);
}
